























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import YKDClass from '@/model/class/class'

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component
export default class TodayTaskEmpty extends Vue {
  @ModuleStudyPlan.Action('controlAllStudyPlanModal')
  controlAllStudyPlanModal!: Function

  @Prop()
  ykdClass!: YKDClass

  showAllStudyPlanModal() {
    this.controlAllStudyPlanModal(true)
  }
}
